<template>
  <div style="display: inline-block">
    <el-upload
      v-if="uploadType == 'img'"
      ref="myUpload"
      class="upload-demo"
      :style="uploadStyle"
      :action="action"
      :headers="headers"
      :accept="allowType && allowType.toString()"
      :multiple="multiple"
      :drag="drag"
      :list-type="listType"
      :show-file-list="showFileList"
      :before-upload="beforeUpload"
      :before-remove="handleRemove"
      :on-preview="preview"
      :on-success="success"
      :on-exceed="exceed"
      :disabled="disabled"
      :limit="limit"
      :data="$uploadData"
    >
      <slot />
    </el-upload>
    <el-upload
      v-else
      ref="myUpload"
      class="upload-demo"
      :style="uploadStyle"
      :action="action"
      :headers="headers"
      :accept="allowType && allowType.toString()"
      :multiple="multiple"
      :drag="drag"
      :limit="limit"
      :file-list="fileList"
      :list-type="listType"
      :show-file-list="showFileList"
      :before-upload="beforeUpload"
      :before-remove="handleRemove"
      :on-preview="preview"
      :on-success="success"
      :on-change="change"
      :disabled="disabled"
      :on-remove="onRemove"
      :data="$uploadData"
    >
      <slot />
    </el-upload>
    <el-dialog
      width="600px"
      :title="isFile ? '文件查看' : '图片预览'"
      :visible.sync="dialogTableVisible"
      @click.native.stop
    >
      <div
        class="prev-container"
        style="display: flex; align-items: center; justify-content: center"
        @click.stop
      >
        <img
          v-if="fileUrl"
          :src="fileUrl"
          style="width: auto; height: auto; max-width: 100%"
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
export default {
  name: 'Uploader',
  props: {
    buttonType: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: '/externalApplication/upload'
      // default: '/file/upload'
    },
    allowType: {
      type: Array, // 允许文件类型
      default: null
    },
    allowSize: {
      type: Number, // 允许文件大小kb
      default: 10
    },
    fileName: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: null
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    },
    actionPath2: {
      // 自定义的上传地址
      type: String,
      default: ''
    },
    uploadType: {
      // 单个图片上传
      type: String,
      default: 'img'
    },
    styles: {
      // 样式
      type: Object,
      default: () => {}
    },
    multiple: {
      // 是否多选
      type: Boolean,
      default: () => {
        return false
      }
    },
    showFileList: {
      // 是否显示已上传文件列表
      type: Boolean,
      default: () => {
        return false
      }
    },
    listType: {
      // 文件列表的类型
      type: String,
      default: () => {
        return 'text'
      }
    },
    drag: {
      // 是否启用拖拽上传
      type: Boolean,
      default: () => {
        return false
      }
    },
    uploadStyle: {
      // 样式
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      headers: {
        'S-Token': getToken()
      },
      action: this.actionPath(),
      dialogTableVisible: false,
      uploadeFileName: '',
      fileUrl: ''
    }
  },
  computed: {
    isFile() {
      const index = this.uploadeFileName.lastIndexOf('.') // 获取指定字符串最后一次出现的位置，返回index
      const str = this.uploadeFileName.substr(index + 1)
      return ['.pdf', '.doc', '.docx', '.xls', '.xlsx'].indexOf(str.toLowerCase()) !== -1
    }
  },
  mounted() {
    if (this.$isInFrame) {
      this.headers = {
        'X-Token': getToken()
      }
    }
    const isConsole = sessionStorage.getItem('isConsole')
    if (isConsole) {
      this.headers = {
        'C-Token': getToken()
      }
    }
    if (this.$isInKa) {
      this.headers = {
        'sso-Token': getToken()
      }
    }
  },
  methods: {
    aaa() {},
    resetFileList() {
      console.log('执行了')
    },
    actionPath() {
      return this.actionPath2
        ? this.actionPath2
        : process.env.VUE_APP_BASE_API + this.path
    },
    success(res, file, fileList) {
      if (res.code === 511) {
        this.$message.warning(res.message)
        return
      }
      this.$emit('uploadSuccess', res, file, fileList)
    },
    progress(event, file) {
      this.$emit('uploadProgress', event, file)
    },
    exceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit}个文件，本次选择了 ${fileList.length} 个文件`
      )
      this.$emit('exceed', files)
    },
    error(e) {
      this.$emit('uploadError', e)
    },
    remove(e) {
      this.$emit('uploadRemove', e)
    },
    preview(file) {
      console.log(file, 'file')
      this.dialogTableVisible = true
      this.uploadeFileName = file.name
      this.fileUrl =
        file.code === 200 && file.response.data ? file.response.data : file.url
    },
    change(file, fileList) {
      this.$emit('uploadFileList', file, fileList)
    },
    beforeUpload(file) {
      let typeName = '图片'
      // eslint-disable-next-line eqeqeq
      if (this.uploadType == 'file') {
        typeName = '文件'
      }
      if (this.allowType) {
        var index = this.allowType.indexOf(
          file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
        )
        if (index < 0) {
          this.$message({
            message: `${typeName}格式不正确`,
            type: 'warning'
          })
          return false
        }
      }
      if (this.allowSize) {
        const b = file.size
        const isLtSize = b > this.allowSize * 1024
        const sizeStr =
          this.allowSize >= 1024
            ? `${Math.round((this.allowSize / 1024) * 100) / 100}MB`
            : `${this.allowSize}KB`
        if (isLtSize) {
          this.$message.error(`${typeName}不能超过${sizeStr}哦`)
          return false
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(fileList, 'fileList remove')
      this.$emit('handleRemove', file, fileList)
    },
    onRemove(file, fileList) {
      this.$emit('onRemove', file, fileList)
    }
  }
}
</script>
<style lang="scss" scoped>
// .logo-uploader.onlytype /deep/ .el-upload{
//   border: 0px dashed #d9d9d9;
// }
// .logo-uploader /deep/ .el-upload {
//   border: 1px dashed #d9d9d9;
//   border-radius: 6px;
//   background: #f7f7f7;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
//   &:hover {
//     border-color: $wit-primary;
//   }
//   .logo-uploader-icon {
//     font-size: 28px;
//     color: #8c939d;
//     width: 178px;
//     height: 178px;
//     line-height: 178px;
//     text-align: center;
//   }
//   .avatar {
//     width: 178px;
//     height: 178px;
//     display: block;
//   }
// }

// .upload-demo {
//   // display: inline-block;
//   background: #f7f7f7;
// }
</style>
